import React, { useEffect } from 'react';
import './AboutUs.css';
import BackButton from './backbutton/BackButton';

//varaible called aboutus set equal to a function that runs when the page loads
const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

//returns a div with a header, back button and a p tag
  return (
    <div className="about-container">
      <header className="about-header">
        <BackButton/>
        <h1 className="about-title">About clubsta</h1>
      </header>

    <p className="about-content" style={{ textAlign: 'center' }}>Clubsta's ambition is to provide a central directory for every running club in the world.</p>
    <p className="about-content" style={{ textAlign: 'center' }}>Our aim is to build a directory that offers maximal selection, clean data and a great user experience. </p>

    
    </div>
  );
};

export default AboutUs;